module.exports = __webpack_public_path__ + "static/afterclimb_logo-65ecc9f2fa7561928dc6b39ca6790589.jpg";